import React from 'react';
import fleetParadeImageSrc from '../../../assets/images/svgs/fleet-parade.svg';

const BackgroundFleetParade = () => {
	return <img id={'fleet-parade'} src={fleetParadeImageSrc} alt="the fleet parade"/>;
};

export { BackgroundFleetParade };
